export function isMobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
}

export function resizedThumbnail(url, height) {
    let searchParams = new URLSearchParams(url);

    if(height > 0) {
        searchParams.set('height',height);
    }

    //console.log('current thumb', searchParams, 'res thumb', searchParams.toString().replace('=&', '?'));

    return decodeURIComponent(decodeURIComponent(searchParams.toString().replace('=&', '?')));
}

export function replaceLinks(text) {
    let urlRegex = /(http?:\/\/[^\s]+)/g;

    if(text) {
        return text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="_blank">' + url + '</a>';
        })
    }
}